import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import { publish } from "@jutro/events";
import { REQUEST_HANDLER_TYPE } from "../HttpRequestBuilder";
import { eventTopicMap } from "../common";
export var analyticsHandler = _defineProperty({}, REQUEST_HANDLER_TYPE.TRACE, function (event, payload) {
  publish(eventTopicMap[event], payload);
});